import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M28 6H4c-.55 0-1 .45-1 1v17c0 .53.21 1.04.59 1.41S4.47 26 5 26h22c.53 0 1.04-.21 1.41-.59S29 24.53 29 24V7c0-.55-.45-1-1-1m-1 16.73L19.66 16 27 9.28zM5 9.27l7.34 6.72L5 22.72zM6.57 8h18.86L16 16.64zm7.24 9.35 1.51 1.38c.19.17.43.26.68.26s.48-.09.68-.26l1.51-1.38L25.44 24H6.57l7.25-6.65z"
    />
  </svg>
);
const SvgIconMessages = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconMessages);
export default Memo;
